/* assets/armonia-global.js
   Namespace Armonia: helper condivisi (tracking, soldi, storage, motion).
   Niente librerie. Le feature (preferiti, consegna, barra spedizione)
   arrivano nelle fasi successive e si appoggiano a questo file. */
(function () {
  'use strict';

  var A = (window.Armonia = window.Armonia || {});
  var cfg = A.config || {};
  window.dataLayer = window.dataLayer || [];

  /* Tracking: unico punto di ingresso verso dataLayer (GA4 / Meta via GTM) */
  A.track = function (name, params) {
    var payload = { event: name };
    if (params) {
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
      }
    }
    window.dataLayer.push(payload);
  };


  /* Soldi nel formato del negozio (Impostazioni > Mercati / Valuta > Formattazione valuta).
     Stesse regole dei token Shopify, così il prezzo scritto dal server e quello aggiornato dal JS sono identici. */
  function armoniaFormatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    var fmt = format || (cfgMoneyFormat());
    if (!fmt) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat((window.Armonia && window.Armonia.config && window.Armonia.config.locale) || 'it-IT', { style: 'currency', currency: currency }).format(value);
      } catch (e) {
        return value.toFixed(2).replace('.', ',') + ' €';
      }
    }
    function num(decimals, thousands, decimal) {
      var n = value.toFixed(decimals).split('.');
      n[0] = n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return n[1] ? n[0] + decimal + n[1] : n[0];
    }
    return String(fmt).replace(/\{\{\s*(\w+)\s*\}\}/, function (m, t) {
      switch (t) {
        case 'amount': return num(2, ',', '.');
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', ',');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        default: return num(2, ',', '.');
      }
    });
  }
  function cfgMoneyFormat() {
    return (window.Armonia && window.Armonia.config && window.Armonia.config.moneyFormat) || '';
  }

  A.formatMoney = function (cents) { return armoniaFormatMoney(cents); };

  /* localStorage sicuro (Safari privato, quota, ecc.) */
  A.storage = {
    get: function (key, fallback) {
      try {
        var raw = window.localStorage.getItem('armonia:' + key);
        return raw === null ? fallback : JSON.parse(raw);
      } catch (e) {
        return fallback;
      }
    },
    set: function (key, value) {
      try {
        window.localStorage.setItem('armonia:' + key, JSON.stringify(value));
        return true;
      } catch (e) {
        return false;
      }
    }
  };

  A.prefersReducedMotion = function () {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  /* Tracking dichiarativo:
     <a data-armonia-track="monica_click" data-armonia-track-params='{"position":"home"}'> */
  document.addEventListener(
    'click',
    function (event) {
      var el = event.target.closest && event.target.closest('[data-armonia-track]');
      if (!el) return;
      var params = {};
      var raw = el.getAttribute('data-armonia-track-params');
      if (raw) {
        try {
          params = JSON.parse(raw);
        } catch (e) {
          params = {};
        }
      }
      A.track(el.getAttribute('data-armonia-track'), params);
    },
    true
  );
})();
